import { ACTION_TYPES } from "./types"
import { InvoiceDto } from "../models"
import { PatchPayload } from "../../pricing/services"

export const patchInvoice = (
    id: string,
    payload: PatchPayload
) => {
    return {
        type: ACTION_TYPES.PATCH_INVOICE,
        payload: {
            id : id,
            payload: payload,
        },
    }
}

export const patchInvoiceSuccess = (
    res: InvoiceDto
) => {
    return {
        type: ACTION_TYPES.PATCH_INVOICE_SUCCESS,
        payload: {
            payload: res,
        },
    }
}

export const patchInvoiceFailure = () => {
    //handle failure
    return
}


// WEBPACK FOOTER //
// ./src/state/invoice/actions/actions.ts